import { Link, useLocation } from "react-router-dom";
import { Phone, MessageSquare, Calendar, Sun } from "lucide-react";
import { JEREMY } from "@/lib/jeremy";

export default function StickyQualifyCTA() {
  const location = useLocation();
  if (location.pathname === "/qualify" || location.pathname === "/thank-you") return null;
  const digits = JEREMY.contact.phone.replace(/\D/g, "");

  return (
    <>
      {/* Mobile: 4-action sticky bar */}
      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#FDFBF7] border-t border-[#E5E0D8] shadow-[0_-8px_24px_-8px_rgba(15,56,44,0.15)]" data-testid="sticky-mobile-bar">
        <div className="grid grid-cols-4 divide-x divide-[#E5E0D8]">
          <a href={`tel:${digits}`} className="flex flex-col items-center gap-1 py-2.5 text-[#0F382C]" data-testid="sticky-mobile-call">
            <Phone className="w-4 h-4" />
            <span className="text-[10px] font-mono-metric uppercase tracking-widest">Call</span>
          </a>
          <a href={`sms:${digits}`} className="flex flex-col items-center gap-1 py-2.5 text-[#0F382C]" data-testid="sticky-mobile-text">
            <MessageSquare className="w-4 h-4" />
            <span className="text-[10px] font-mono-metric uppercase tracking-widest">Text</span>
          </a>
          <Link to="/qualify" className="flex flex-col items-center gap-1 py-2.5 text-[#0F382C]" data-testid="sticky-mobile-schedule">
            <Calendar className="w-4 h-4" />
            <span className="text-[10px] font-mono-metric uppercase tracking-widest">Schedule</span>
          </Link>
          <Link to="/qualify?upload=1" className="flex flex-col items-center gap-1 py-2.5 bg-[#D97706] text-[#FDFBF7]" data-testid="sticky-mobile-qualify">
            <Sun className="w-4 h-4" />
            <span className="text-[10px] font-mono-metric uppercase tracking-widest">Review Bill</span>
          </Link>
        </div>
      </div>

      {/* Desktop: floating pill */}
      <Link
        to="/qualify?upload=1"
        className="hidden md:inline-flex fixed bottom-8 right-8 z-40 btn-solar shadow-2xl"
        data-testid="sticky-qualify-desktop-btn"
      >
        <Sun className="w-4 h-4" /> Have Jeremy Review My Bill
      </Link>
    </>
  );
}
